var _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path10, _path11, _path12, _path13;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgMotivationIco(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 83,
    height: 81,
    viewBox: "0 0 83 81",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M39.7602 6.1087V1H18.8906V6.1087",
    stroke: "#EEEBE7",
    strokeWidth: 2,
    strokeMiterlimit: 10
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M46.7174 79.3333H1.5V4.40576H18.8913V11.2174H39.7609V4.40576H57.1522V28.2463",
    stroke: "#EEEBE7",
    strokeWidth: 2,
    strokeMiterlimit: 10,
    strokeLinecap: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M50.1965 52.0869V11.2173H39.7617",
    stroke: "#EEEBE7",
    strokeWidth: 2,
    strokeMiterlimit: 10,
    strokeLinecap: "round"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M57.1514 45.2753C57.1514 49.0373 60.266 52.0869 64.1079 52.0869C67.9499 52.0869 71.0645 49.0373 71.0645 45.2753V41.8695C71.0645 38.1076 67.9499 35.0579 64.1079 35.0579C60.266 35.0579 57.1514 38.1076 57.1514 41.8695V45.2753Z",
    stroke: "#EEEBE7",
    strokeWidth: 2,
    strokeMiterlimit: 10,
    strokeLinecap: "round"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M67.5859 52.0869V55.4927L77.2828 58.8321C78.5341 59.3572 79.6006 60.2303 80.3501 61.3432C81.0995 62.4561 81.499 63.7599 81.499 65.0929V79.3333",
    stroke: "#EEEBE7",
    strokeWidth: 2,
    strokeMiterlimit: 10,
    strokeLinecap: "round"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M60.6298 52.0869V55.4927L50.933 58.8321C49.6817 59.3572 48.6152 60.2303 47.8657 61.3432C47.1163 62.4561 46.7168 63.7599 46.7168 65.0929V79.3333",
    stroke: "#EEEBE7",
    strokeWidth: 2,
    strokeMiterlimit: 10,
    strokeLinecap: "round"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M74.543 69.1162V79.3336",
    stroke: "#EEEBE7",
    strokeWidth: 2,
    strokeMiterlimit: 10,
    strokeLinecap: "round"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M53.6738 69.1162V79.3336",
    stroke: "#EEEBE7",
    strokeWidth: 2,
    strokeMiterlimit: 10,
    strokeLinecap: "round"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M41.5736 72.5216H8.45703V11.2173H13.6744",
    stroke: "#EEEBE7",
    strokeWidth: 2,
    strokeMiterlimit: 10
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    d: "M25.8477 28.2462L29.3259 31.652L39.7607 21.4346",
    stroke: "#EEEBE7",
    strokeWidth: 2,
    strokeMiterlimit: 10
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    d: "M31.0538 21.6047C29.3682 21.2702 27.6192 21.4326 26.0279 22.0715C24.4366 22.7103 23.0745 23.7968 22.1139 25.1936C21.1532 26.5904 20.6371 28.2347 20.6309 29.9187C20.6247 31.6027 21.1286 33.2507 22.0789 34.6543C23.0292 36.0579 24.3832 37.154 25.9697 37.8041C27.5562 38.4541 29.304 38.629 30.992 38.3064C32.68 37.9839 34.2324 37.1785 35.4529 35.992C36.6734 34.8056 37.5072 33.2914 37.8489 31.641",
    stroke: "#EEEBE7",
    strokeWidth: 2,
    strokeMiterlimit: 10,
    strokeLinecap: "round"
  })), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    d: "M25.8477 52.087L29.3259 55.4928L39.7607 45.2754",
    stroke: "#EEEBE7",
    strokeWidth: 2,
    strokeMiterlimit: 10
  })), _path13 || (_path13 = /*#__PURE__*/React.createElement("path", {
    d: "M31.0538 45.4455C29.3682 45.111 27.6192 45.2735 26.0279 45.9123C24.4366 46.5511 23.0745 47.6376 22.1139 49.0344C21.1532 50.4312 20.6371 52.0756 20.6309 53.7595C20.6247 55.4435 21.1286 57.0915 22.0789 58.4951C23.0292 59.8987 24.3832 60.9948 25.9697 61.6449C27.5562 62.295 29.304 62.4698 30.992 62.1472C32.68 61.8247 34.2324 61.0193 35.4529 59.8328C36.6734 58.6464 37.5072 57.1322 37.8489 55.4818",
    stroke: "#EEEBE7",
    strokeWidth: 2,
    strokeMiterlimit: 10,
    strokeLinecap: "round"
  })));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgMotivationIco);
export default __webpack_public_path__ + "static/media/motivation-ico.446b6f12a57b15d9483291137bad98a6.svg";
export { ForwardRef as ReactComponent };